
import React from 'react';
import { Plus } from 'lucide-react';

export const PlusIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <Plus strokeWidth={1.5} {...props} />
);
